import { Stack } from '@eneco/sparky';

import { stackContainerClass } from './selfservice.css';

export const StackContainer = (props: React.ComponentProps<typeof Stack>) => (
  <Stack className={stackContainerClass} {...props} />
);
